import { inject, injectable } from 'inversify';
import {
  ProfileRepositoryInterface,
  UpdateProfileParams,
} from '../domain/ProfileRepositoryInterface';
import ProfileService from 'src/features/profile/data/service/ProfileService';

@injectable()
class ProfileRepository implements ProfileRepositoryInterface {
  @inject(ProfileService) private readonly profileService!: ProfileService;

  public async updateProfile(params: UpdateProfileParams) {
    const response = await this.profileService.updateProfile(params);

    return response.data;
  }
}

export default ProfileRepository;
